import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMooComponent } from './simple-icons-moo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMooComponent ],
    exports:      [ SimpleIconsMooComponent ],
    bootstrap:    []
})
export class SimpleIconsMooModule {}
